import { P, FF } from "../../styles/tokens";

export default function ArboLogo({ size = 32, showText = true, animated = false }) {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
      {animated && (
        <style>{`
          @keyframes arbo-pulse {
            0%, 100% { transform: scale(1); }
            50% { transform: scale(1.06); }
          }
          @keyframes arbo-leaf {
            0% { transform: translate(0, 0); opacity: 0.85; }
            40% { transform: translate(6px, -8px); opacity: 0; }
            41% { transform: translate(0, 0); opacity: 0; }
            70% { opacity: 0; }
            100% { opacity: 0.85; }
          }
        `}</style>
      )}
      <svg width={size} height={size} viewBox="0 0 32 32" fill="none">
        <rect x="13" y="20" width="6" height="8" rx="2" fill={P.brand.bark} />
        <g style={animated ? { animation: "arbo-pulse 1.8s ease-in-out infinite", transformOrigin: "16px 14px" } : undefined}>
          <ellipse cx="16" cy="16" rx="11" ry="9" fill={P.ingresos.mid} opacity="0.25" />
          <ellipse cx="16" cy="14" rx="9" ry="8" fill={P.ingresos.mid} opacity="0.5" />
          <ellipse cx="16" cy="11" rx="7" ry="7" fill={P.ingresos.base} />
        </g>
        <circle cx="22" cy="8" r="2.5" fill={P.brand.leaf}
          style={animated ? { animation: "arbo-leaf 2.4s ease-in-out infinite", transformOrigin: "22px 8px" } : { opacity: 0.85 }}
        />
      </svg>
      {showText && (
        <span style={{ fontSize: size * 0.7, fontWeight: 900, color: P.ingresos.base, fontFamily: FF, letterSpacing: "-0.5px" }}>
          arbo
        </span>
      )}
    </div>
  );
}
